<template>
  <footer class="footer border-top py-4">
    <div class="container">
      <div class="d-flex flex-column flex-lg-row align-items-center justify-content-lg-between gap-2 gap-lg-3">
        <span>© 2022 RentEase</span>
        <div class="d-flex justify-content-center justify-content-lg-end gap-4">
          <a href="#">About</a>
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
        </div>
      </div>
    </div>
    
      <Registration />
      <Login />

  </footer>
</template>

<script>
import Registration from "@/components/Registration.vue";
import Login from "@/components/Login.vue";

export default {
  name: "FooterNavigation",
  components: {
    Registration,
    Login
  },
};

</script>
